import { EnterprisePermittedProductsV1NaptimeResource } from './__generated__/EnterprisePermittedProductsV1';

export default class EnterprisePermittedProductsV1 extends EnterprisePermittedProductsV1NaptimeResource {
  static RESOURCE_NAME = 'enterprisePermittedProducts.v1' as const;
}
